
import axios from "../../axios";

export function reports__get_statictics() {
    return (async dispatch => {
        try {
            let response = await axios.get(`Reports/statistics`);
            dispatch({
                type: "REPORTS_STATISTICS_FULFILLED",
                payload: {
                    data: response.data,
                    error: null
                }
            });
        }
        catch (e) {
            dispatch({
                type: "REPORTS_STATISTICS_REJECTED",
                payload: {
                    data: null,
                    error: e
                }
            });
        }
    });
}
export function reports__getActives(skip, limit) {
    return (async (dispatch) => {
        try {
            let response = await axios.get(`Reports/active?offset=${skip}&limit=${limit}`);
            dispatch({
                type: "REPORTS_ACTIVE_FULFILLED",
                payload: {
                    data: response.data,
                    error: null
                }
            });
        }
        catch (e) {
            dispatch({
                type: "REPORTS_ACTIVE_REJECTED",
                payload: {
                    data: null,
                    error: escape
                }
            });
        }
    });
}

export function reports__actives_read(id) {
    return (async (dispatch) => {
        try {
            await axios.patch(`Reports/${id}/read`, null);
        }
        catch (e) {
            dispatch({
                type: "REPORTS_READ_REJECTED",
                payload: {
                    data: null,
                    error: e
                }
            });
        }
    });
}
export function reports__actives_unread(id) {
    return (async (dispatch) => {
        try {
            await axios.patch(`Reports/${id}/unread`, null);
        }
        catch (e) {
            dispatch({
                type: "REPORTS_UNREAD_REJECTED",
                payload: {
                    data: null,
                    error: e
                }
            });
        }
    });
}
export function reports__actives_delete(id) {
    return (async (dispatch) => {
        try {
            await axios.patch(`Reports/${id}/archive`, null);
        }
        catch (e) {
            dispatch({
                type: "REPORTS_ARCHIVE_REJECTED",
                payload: {
                    data: null,
                    error: e
                }
            });
        }
    });
}
export function reports__action_new(id, text) {
    return (async (dispatch) => {
        try {
            await axios.post(`Reports/${id}/actions`, { remark: text });
        }
        catch (e) {
            dispatch({
                type: "REPORTS_ACTION_REJECTED",
                payload: {
                    data: null,
                    error: e
                }
            });
        }
    })
}

export function reports__actives_onItemsPerPage(count) {
    return (dispatch => {
        dispatch({
            type: "REPORTS_ACTIVES_ITEMPERPAGE",
            payload: {
                count
            }
        });
    });
}
export function reports__actives_onCurrentPageChanged(page) {
    return (dispatch => {
        dispatch({
            type: "REPORTS_ACTIVE_CURRENTPAGE",
            payload: {
                page
            }
        });
    });
}

export function reports__getArchived(skip, limit) {
    return (async (dispatch) => {
        try {
            let response = await axios.get(`Reports/archived?offset=${skip}&limit=${limit}`);
            dispatch({
                type: "REPORTS_ARCHIVED_FULFILLED",
                payload: {
                    data: response.data,
                    error: null
                }
            });
        }
        catch (e) {
            dispatch({
                type: "REPORTS_ARCHIVED_REJECTED",
                payload: {
                    data: null,
                    error: e
                }
            });
        }
    });
}
export function reports__archived_onItemsPerPage(count) {
    return (dispatch => {
        dispatch({
            type: "REPORTS_ARCHIVED_ITEMPERPAGE",
            payload: {
                count
            }
        });
    });
}
export function reports__archived_onCurrentPageChanged(page) {
    return (dispatch => {
        dispatch({
            type: "REPORTS_ARCHIVED_CURRENTPAGE",
            payload: {
                page
            }
        });
    });
}
export function reports__archived_unbox(id) {
    return (async (dispatch) => {
        try {
            await axios.patch(`Reports/${id}/unarchive`, null);
        }
        catch (e) {
            dispatch({
                type: "REPORTS_UNARCHIVED_REJECTED",
                payload: {
                    data: null,
                    error: encodeURI
                }
            });
        }
    });
}

//MQTT triggered
export function reports__active_new(data) {
    return (dispatch => {
        dispatch({
            type: "REPORTS_ACTIVE_NEW",
            payload: { data }
        });
    });
}
export function reports__actives_read_done(data) {
    return (async (dispatch) => {
        dispatch({
            type: "REPORTS_READ_FULFILLED",
            payload: {
                data: data,
                error: null
            }
        });
    })
}
export function reports__actives_unread_done(data) {
    return (async (dispatch) => {
        dispatch({
            type: "REPORTS_UNREAD_FULFILLED",
            payload: {
                data: data,
                error: null
            }
        });
    })
}
export function reports__actives_delete_done(data) {
    return (async (dispatch) => {
        dispatch({
            type: "REPORTS_ARCHIVE_FULFILLED",
            payload: {
                data: data,
                error: null
            }
        });
    })
}
export function reports__action_fulfilled(data) {
    return (dispatch => {
        dispatch({
            type: "REPORTS_ACTION_NEW",
            payload: {
                data
            }
        });
    });
}
export function reports__archived_unbox_done(data) {
    return (dispatch => {
        dispatch({
            type: "REPORTS_UNARCHIVED_FULFILLED",
            payload: {
                data: data,
                error: null
            }
        });

    });
}




// WEBPACK FOOTER //
// ./src/redux/actions/reports.js